import { render, staticRenderFns } from "./SelecaoUfMobile.vue?vue&type=template&id=dd2de334&scoped=true&"
import script from "./SelecaoUfMobile.vue?vue&type=script&lang=js&"
export * from "./SelecaoUfMobile.vue?vue&type=script&lang=js&"
import style0 from "./SelecaoUfMobile.vue?vue&type=style&index=0&id=dd2de334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2de334",
  null
  
)

export default component.exports